import {
  apiRequest,
  monitoringGetAllHosts,
  monitoringGetAllPeriods,
  getGraphPingServer5Minute,
  getGraphPingServer30Minute,
  getGraphPingServer1Hour,
  getGraphPingServer6Hour,
  getGraphPingServer1Day,
  getGraphPingServer1Week,
  getGraphPingServer1WeekHistory,
  getGraphPingServer1Month,
  getGraphPingServer1MonthHistory,
  getGraphPingServer6Month,
  getGraphPingServer6MonthHistory,
} from "../../../../../services/adapters/base";

class IndexRepository {
  fetchAllHosts = async (query) => {
    return await apiRequest(
      "get",
      monitoringGetAllHosts,
      {
        params: query,
      },
      true
    );
  };

  fetchAllPeriods = async (query) => {
    return await apiRequest(
      "get",
      monitoringGetAllPeriods,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer5Minute = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer5Minute,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer30Minute = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer30Minute,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer1Hour = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer1Hour,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer6Hour = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer6Hour,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer1Day = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer1Day,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer1Week = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer1Week,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer1WeekHistory = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer1WeekHistory,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer1Month = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer1Month,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer1MonthHistory = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer1MonthHistory,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer6Month = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer6Month,
      {
        params: query,
      },
      true
    );
  };

  fetchGraphPingServer6MonthHistory = async (query) => {
    return await apiRequest(
      "get",
      getGraphPingServer6MonthHistory,
      {
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
